import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { Container as MuiContainer } from "@mui/material";
import { ColumnsLayoutFooter } from "@components/common";
import { ColumnsLayoutHeader } from "./ColumnsLayoutHeader";

const Container = styled(MuiContainer)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(35, 30, 50, 30)};
  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: ${({ theme }) => theme.spacing(16, 3, 40, 3)};
  }
`;

const HeaderContainer = styled.div`
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

interface Props {
  children: ReactNode;
  testId?: string;
}

export const ColumnsLayout = ({ children, testId }: Props) => (
  <>
    <Container data-testid={testId}>
      <HeaderContainer>
        <ColumnsLayoutHeader />
      </HeaderContainer>
      <InnerContainer>{children}</InnerContainer>
    </Container>
    <ColumnsLayoutFooter />
  </>
);
